var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0305 19.0227C15.8555 19.0052 15.6455 19.0052 15.453 19.0227C11.288 18.8827 7.98047 15.4702 7.98047 11.2702C7.98047 6.98274 11.4455 3.50024 15.7505 3.50024C20.038 3.50024 23.5205 6.98274 23.5205 11.2702C23.503 15.4702 20.1955 18.8827 16.0305 19.0227Z",
    stroke: "#FAA60E",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7158 6.99976C32.1108 6.99976 34.8408 9.74726 34.8408 13.1248C34.8408 16.4323 32.2158 19.1273 28.9433 19.2498C28.8033 19.2323 28.6458 19.2323 28.4883 19.2498",
    stroke: "#FAA60E",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28172 25.4798C3.04672 28.3148 3.04672 32.9348 7.28172 35.7523C12.0942 38.9723 19.9867 38.9723 24.7992 35.7523C29.0342 32.9173 29.0342 28.2973 24.7992 25.4798C20.0042 22.2773 12.1117 22.2773 7.28172 25.4798Z",
    stroke: "#FAA60E",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0938 35.0002C33.3538 34.7377 34.5437 34.2302 35.5237 33.4777C38.2537 31.4302 38.2537 28.0527 35.5237 26.0052C34.5612 25.2702 33.3888 24.7802 32.1463 24.5002",
    stroke: "#FAA60E",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroup);
export default __webpack_public_path__ + "static/media/userGroup.7d81c13932d8be2ac0ce8e20dddf2007.svg";
export { ForwardRef as ReactComponent };